import i18n from '@/i18n/config';

// 獲取當前語言對應的值
export function getLocalizedValue(jsonb: Record<string, string> | undefined, fallback = ''): string {
  if (!jsonb || typeof jsonb !== 'object') return fallback;
  
  const lang = i18n.language;
  // 嘗試完整語言代碼
  if (jsonb[lang]) return jsonb[lang];
  // 嘗試語言基礎代碼
  const baseLang = lang.split('-')[0];
  if (jsonb[baseLang]) return jsonb[baseLang];
  // 嘗試英文
  if (jsonb['en']) return jsonb['en'];
  // 返回第一個可用值
  const values = Object.values(jsonb);
  return values.length > 0 ? values[0] : fallback;
}

export function getLocalizedArray(jsonb: Record<string, string[]> | undefined): string[] {
  if (!jsonb || typeof jsonb !== 'object') return [];
  
  const lang = i18n.language;
  if (Array.isArray(jsonb[lang])) return jsonb[lang];
  const baseLang = lang.split('-')[0];
  if (Array.isArray(jsonb[baseLang])) return jsonb[baseLang];
  if (Array.isArray(jsonb['en'])) return jsonb['en'];
  const values = Object.values(jsonb);
  return values.length > 0 && Array.isArray(values[0]) ? values[0] : [];
}
